// Local UX spike: per-equipment-type accent color for glanceable Talotekniikka /
// Kyvykkyydet cards. Hex via callers' inline style so visibility does not depend on
// Tailwind scanning dynamic class names. Keep / adjust / drop after visual review.
const EQUIPMENT_TYPE_ACCENT: Record<string, string> = {
  air_handling_unit: "#0ea5e9", // sky — IV-kone
  ventilation: "#0ea5e9",
  district_heating_substation: "#f97316", // orange — kaukolämpökeskus
  heat_pump: "#f43f5e",
  heating: "#f43f5e",
  chiller: "#06b6d4",
  cooling: "#06b6d4",
  boiler: "#f59e0b",
  heat_exchanger: "#d97706",
  hot_water_unit: "#3b82f6",
  hot_water: "#3b82f6",
  chilled_beam: "#14b8a6",
  pump_group: "#64748b",
  refrigeration_unit: "#6366f1",
  refrigeration: "#6366f1",
  lighting_system: "#eab308",
  lighting: "#eab308",
  electricity_meter: "#8b5cf6",
  heat_meter: "#d946ef",
  temperature_sensor: "#10b981",
  exhaust_fan: "#38bdf8",
};

const FALLBACK =
  "color-mix(in oklab, var(--muted-foreground) 55%, transparent)";

/** Accent color for an equipment_type slug (or muted fallback). */
export function equipmentTypeAccent(equipmentType: string): string {
  return EQUIPMENT_TYPE_ACCENT[equipmentType] ?? FALLBACK;
}
